// angular
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ITender } from '@tenders/shared/interfaces/tender.interface';
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';

@Component({
  selector: 'pwj-tender-guidelines-section',
  standalone: true,
  imports: [TranslateModule, TranslateDataPipe],
  templateUrl: './tender-guidelines-section.component.html',
  styleUrl: './tender-guidelines-section.component.scss',
})
export class TenderGuidelinesSectionComponent {
  tender = input.required<ITender>();
}
